<style>
</style>

<template>

    <div class="modal dark-panel mt-5">
      <header class="modal-header">
        <slot name="header">
          <h1>{{trans.get('common.confirmdelete')}}</h1>
        </slot>
        <button type="button" class="btn-close" @click="close"> x </button>
      </header>

      <section class="modal-body">
        <slot name="body">
            <form :id="idform" method='get' enctype='multipart/form-data' :action="routesubmit">
                <input type="hidden" name="_token" v-bind:value="csrf">
                <h1>{{trans.get('common.confirmdelete_zone_text')}}</h1>
            </form>
        </slot>
       </section>

      <footer class="modal-footer">
        <div class="row">
            <button type="button" class="btn btn-secondary text-blue_claire" @click="close">
            {{trans.get('common.cancel')}}
            </button>
            &nbsp;
            <button type="button" class="btn btn-primary text-blue_claire" @click="deletezone">
            {{trans.get('common.validate')}}
            </button>
        </div>
      </footer>
    </div>
</template>


<script>

    export default {
        name: "deleteZoneModal",
        props : ['idzone', 'routesubmit'],     
        data : function(){
            return {
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                idform: '',
            };
        },
        mounted: function() {
            this.idform = "deletezone"+this.idzone;
        },
        methods :{
            close() {
                this.$emit('close');
            },
            deletezone(){                
                document.getElementById(this.idform).submit();
            },
        }
    }

</script>
<style>
.button-control {
    background-color: white;
    margin: 5px;
}

.button-control > button {
    height: 24px;
    background: rgb(255, 255, 255) none repeat scroll 0% 0% padding-box;
    padding: 3px 4px 4px 4px;
}

.control-left {
    font-size: 20px;
}

  .modal {
    display: flex;
    height: auto;
  }

  .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #4AAE9B;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }
</style>